import PropTypes from "prop-types";
import { Col, FormGroup, Input, Row } from "reactstrap";
import { useState, useEffect, useContext } from "react";
import { toast } from "../../../../core/helpers/message-helper";
import FormModal from "../../../../core/ui/components/FormModal";
import SelectController from "../../../../core/ui/components/SelectController";
import { selectEmpleadosConReglasOSecuencias } from "../../../../modules/Personas/services/empleados-service";
import { useForm } from "react-hook-form";
import TurnosConvencionesContext from "../../store/modal-convenciones-context";
import {
    editarCuadroTurnoActual,
    selectTurnosSedes,
} from "../../../NominaTurnos/services/nomina-turnos-service";
import DatePicker from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import Toolbar from "react-multi-date-picker/plugins/toolbar";
import moment from "moment";

const REQUIRED_RULE = {
    required: "Este campo es requerido",
};

const FormEditarCuadroTurno = ({ modalState, onCreate }) => {
    const [selectTurnosEmpleados, setSelectTurnosEmpleados] = useState({
        turnosSedes: [],
        empleados: [],
    });

    const { refrescarConvenciones } = useContext(TurnosConvencionesContext);
    const [focusedDate, setFocusedDate] = useState();
    const [fechasEdicionTurno, setFechasEdicionTurno] = useState([]);

    useEffect(async () => {
        const [turnosSedes, empleadosReglas] = await Promise.all([
            selectTurnosSedes(),
            selectEmpleadosConReglasOSecuencias(),
        ]);

        if (!turnosSedes.status || !empleadosReglas.status) {
            const message = !turnosSedes.status
                ? turnosSedes.message
                : empleadosReglas.message;

            return toast.error(message);
        }

        setSelectTurnosEmpleados({
            turnosSedes: turnosSedes.data,
            empleados: empleadosReglas.data,
        });
    }, []);

    const defaultValues = {
        empleados: [],
        fk_nomina_turno_sede: "",
        fechasEdicionTurno: [],
    };

    const form = useForm({ defaultValues });

    const onSubmit = async (data) => {
        const cuadroTurno = {
            ...data,
            fk_nomina_turno_sede: data.fk_nomina_turno_sede.value,
            empleados: data.empleados.map((emp) => emp.value),
            fechasEdicionTurno: fechasEdicionTurno.map((fecha) =>
                moment(new Date(fecha)).format("YYYY-MM-DD")
            ),
        };

        const resp = await editarCuadroTurnoActual(cuadroTurno);
        if (!resp.status) return toast.error(resp.message);

        modalState.close();
        form.reset(defaultValues);
        onCreate(resp);
        refrescarConvenciones();
    };

    return (
        <FormModal
            size="lg"
            form={form}
            isOpen={modalState.show}
            onSubmit={onSubmit}
            id="formEditarTurnos"
            headerTitle="Editar Turnos"
            closeModal={() => modalState.close()}
        >
            <Row>
                <Col sm={6}>
                    <SelectController
                        label="Colaborador"
                        isMulti={true}
                        options={selectTurnosEmpleados.empleados.map(
                            (empleado) => {
                                return {
                                    label: empleado.info_persona,
                                    value: empleado.id,
                                };
                            }
                        )}
                        name="empleados"
                        rules={REQUIRED_RULE}
                        errors={form.formState.errors}
                        control={form.control}
                    />
                </Col>
                <Col sm={6}>
                    <SelectController
                        label="Turno"
                        errors={form.formState.errors}
                        control={form.control}
                        name="fk_nomina_turno_sede"
                        rules={REQUIRED_RULE}
                        options={selectTurnosEmpleados.turnosSedes.map(
                            (turnoSede) => {
                                return {
                                    label: turnoSede.info_asignacion_turno,
                                    value: turnoSede.id,
                                };
                            }
                        )}
                    />
                </Col>
                <Col sm={12}>
                    <FormGroup>
                        <label>Fechas</label> <br />
                        <DatePicker
                            multiple
                            value={fechasEdicionTurno}
                            onChange={(dates) => setFechasEdicionTurno(dates)}
                            sort
                            onFocusedDateChange={setFocusedDate}
                            onClose={() => setFocusedDate(undefined)}
                            plugins={[
                                <DatePanel
                                    markFocused
                                    focusedClassName="bg-red"
                                    key={"datePanel"}
                                />,
                                <Toolbar
                                    position="bottom"
                                    key={"toolbar"}
                                    sort={["close"]}
                                />,
                            ]}
                            mapDays={({ date, isSameDate }) => {
                                let props = {};

                                if (!isSameDate(date, focusedDate)) return;

                                props.style = { backgroundColor: "red" };

                                return props;
                            }}
                            render={<CustomInput />}
                        />
                    </FormGroup>
                </Col>
            </Row>
        </FormModal>
    );
};

function CustomInput({ onFocus, value, onChange }) {
    return <Input onFocus={onFocus} value={value} onChange={onChange} />;
}
FormEditarCuadroTurno.propTypes = {
    modalState: PropTypes.object,
    onCreate: PropTypes.func,
};

CustomInput.propTypes = {
    onFocus: PropTypes.func,
    value: PropTypes.string,
    onChange: PropTypes.func,
};

export default FormEditarCuadroTurno;
